import React from "react";
import { ChatBoxListStateContext } from "../ChatBoxListContext";

export const useChatBoxListState = () => {
	return React.useContext(ChatBoxListStateContext);
};
